export default {
  'transactions.title': 'Transaction History',
  'transactions.empty': 'No Data',
  'transactions.order.no': 'Order Number',
  'transactions.order.status': 'Order Status',
  'transactions.order.purchase_date': 'Purchase Date',
  'transactions.order.item': 'Purchased Item',
  'transactions.order.amount': 'Amount Paid',
  'transactions.order.payment': 'Payment Method',
  'transactions.order.credit_card': 'Credit Card',
  'transactions.last_month': 'Last Month',
  'transactions.purchase_complete': 'Purchase Complete',
  'transactions.view_store_value_card': 'View Stored Value Card',
  'transactions.view_tickets': 'View Tickets',
  'transactions.trade_record': 'Transaction Record',
} as Record<string, string>;
